export default __webpack_public_path__ + "static/char-t-21-ja-bb4cfa1f391eb852a9f51e6c2967a9de.png";